import type { ChartItem } from 'ui/uiConfig/components/Chart/Chart.types'
import type { AppliedSettingSeries } from './appliedSettingValues.types'

const UNITLESS_Y_AXIS_ID = 'y'

type UnitAxisScale = {
  position: 'left' | 'right'
  grid: { drawOnChartArea: boolean }
  title?: { display: true; text: string }
}

type UnitAxesConfig = { options: { scales: Record<string, UnitAxisScale> } }

function toYAxisId({ measurementUnit }: AppliedSettingSeries): string {
  return measurementUnit ? `y_${measurementUnit}` : UNITLESS_Y_AXIS_ID
}

export function toChartItems(series: AppliedSettingSeries[]): ChartItem[] {
  return series.map((item, order) => ({
    title: item.displayTitle,
    display_title: item.displayTitle,
    data_id: item.returnId,
    color: item.color,
    unit: item.measurementUnit,
    order,
    y_axis_id: toYAxisId(item),
  }))
}

export function toChartConfig(series: AppliedSettingSeries[]): UnitAxesConfig {
  const unitByAxisId = new Map<string, string | undefined>()
  series.forEach((item) => {
    const axisId = toYAxisId(item)
    if (!unitByAxisId.has(axisId)) {
      unitByAxisId.set(axisId, item.measurementUnit)
    }
  })

  const scales = Object.fromEntries(
    Array.from(unitByAxisId, ([axisId, unit], index): [string, UnitAxisScale] => [
      axisId,
      {
        position: index === 0 ? 'left' : 'right',
        grid: { drawOnChartArea: index === 0 },
        ...(unit && { title: { display: true, text: unit } }),
      },
    ])
  )

  return { options: { scales } }
}
